export default {
  enums: [
    { id: 'KM_SPOILED' },
    { id: 'KM_LOST' },
    { id: 'KM_DESTROYED' },
  ]
};